module.exports = __webpack_public_path__ + "img/hotel2_1.263fa955.png";